"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackNewsletterSubmitRegistrationClick = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
const trackNewsletterSubmitRegistrationClick = () => (0, libs_tracking_events_1.track)({
    event: `🚀 click`,
    eventMetadata: {
        action: `submit-nl-registration`,
        source: `nl-component`,
    },
    _clear: true,
});
exports.trackNewsletterSubmitRegistrationClick = trackNewsletterSubmitRegistrationClick;
//# sourceMappingURL=trackNewsletter.js.map